import { z } from "zod";

export const LOCALES = ["en", "de"] as const;
export type Locale = (typeof LOCALES)[number];

/** User-defined display names (types, statuses, labels, ...). English is required, other locales fall back to it. */
export const Localized = z.object({ en: z.string().min(1), de: z.string().optional() });
export type Localized = z.infer<typeof Localized>;

/** Picks the best string for `locale` ("de", "de-CH", ...), falling back to English, then any non-empty value. */
export function localize(value: Localized | string | null | undefined, locale: string): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  const lang = locale.slice(0, 2).toLowerCase();
  const map = value as Record<string, string | undefined>;
  return map[lang] || value.en || Object.values(map).find((v): v is string => !!v) || "";
}

/** All non-empty names of a localized value, used to match user input against any locale. */
export function localizedNames(value: Localized | string | null | undefined): string[] {
  if (value == null) return [];
  if (typeof value === "string") return [value];
  return Object.values(value as Record<string, string | undefined>).filter((v): v is string => !!v);
}
